export default __webpack_public_path__ + "static/media/confirmationCircle2.8158363e.svg";